import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { slotGPT, slotTabs, SearchBarTemplate } from "./search-bar.templates";

export default {
    title: "Website/Page Templates/Search/Search Bar",
    render: SearchBarTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        autosuggestEndpoint: "./mock-data/search-bar/autocomplete-tru.json",
        quickLinksEndpoint: "./mock-data/search-bar/quicklinks.json",
        buttonText: "Suchen",
        placeholder: "Suchbegriff eingeben",
        resultsLabel: "Suchergebnisse",
        searchString: "",
        searchFormSelector: "form#website-search-form",
        navTabContainerSelector: "ux-tab-container#search-nav-tabs",
        resultTabContainerSelector: "ux-tab-container#search-result-tabs",
    },
};

export const Default = {
    args: {
        autosuggestEndpoint: undefined,
    },
};

/**
 * In order to enable suggestions, an according API url must be passed to the `autosuggest-endpoint` prop.
 *
 * <a href="./mock-data/search-bar/autocomplete-tru.json" target="_blank">Example API response</a>
 */
export const WithAutoSuggest = {
    args: {
        autosuggestEndpoint: "./mock-data/search-bar/autocomplete-tru.json",
        quickLinksEndpoint: "",
    },
};

/**
 * In order to enable suggestions, an according API url must be passed to the `autosuggest-endpoint` prop.
 *
 * <a href="./mock-data/search-bar/autocomplete-tru.json" target="_blank">Example API response</a>
 */
export const WithAutoSuggestWithQuickLinks = {
    args: {
        autosuggestEndpoint: "./mock-data/search-bar/autocomplete-tru.json",
        quickLinksEndpoint: "./mock-data/search-bar/quicklinks.json",
    },
};

/**
 * When there are only a few autocomplete results, the list should still be displayed in full width.
 */
export const FewAutocompleteResults = {
    args: {
        autosuggestEndpoint: "./mock-data/search-bar/autocomplete-trum.json",
    },
};

/**
 * Navigation tabs must be in sync with the corresponding result tabs.
 *
 * They are provided in the default slot of the `<ux-iws-search-bar>`.
 */
export const WithNavigationTabs = {
    args: {
        searchString: "Laser",
        _slot: slotTabs.trim(),
    },
};

/**
 * An extra button such as the GPT button can be placed in the `"buttons"` slot of the `<ux-iws-search-bar>`.
 *
 * The button's `data-search-tab="tab-gpt"` attribute controls which result tab the button should trigger.
 */
export const WithGPT = {
    args: {
        searchString: "Laser",
        _slot: slotGPT.trim(),
    },
};
